import { render, staticRenderFns } from "./PressureDropWeightChangeList.vue?vue&type=template&id=490d72a6&"
import script from "./PressureDropWeightChangeList.vue?vue&type=script&lang=js&"
export * from "./PressureDropWeightChangeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports